import { render, staticRenderFns } from "./TablesTabs.vue?vue&type=template&id=2720d8c3&"
import script from "./TablesTabs.vue?vue&type=script&lang=js&"
export * from "./TablesTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports